import { render } from "./OcFrontPageContent.vue?vue&type=template&id=79fc0959&scoped=true"
import script from "./OcFrontPageContent.vue?vue&type=script&lang=js"
export * from "./OcFrontPageContent.vue?vue&type=script&lang=js"

import "./OcFrontPageContent.vue?vue&type=style&index=0&id=79fc0959&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fc0959"]])

export default __exports__